import {TIMEOUT_STRING} from "../utils/Constants";

const postMessagePromises = {};

function generateGuid(){
    /**
     * @return {string}
     */
    function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}

function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
    const newGuid = generateGuid();
    message.guid = newGuid;
    postMessagePromises[newGuid] = {};
    postMessagePromises[newGuid].promise = new Promise(function (resolve, reject) {
        postMessagePromises[newGuid].resolve = resolve;
        postMessagePromises[newGuid].reject = reject;
        targetWindow.postMessage(message, targetOrigin);
        if (timeout) {
            setTimeout(() => {
                postMessagePromises[newGuid].resolve(TIMEOUT_STRING);
                console.log(`TimeOut: ${message.method}`);
            },timeout);
        }
    });
    return postMessagePromises[newGuid].promise;
}

var setCurrentDarkMode = () => {};
export function setDarkModeStateListener(darkModeStateListener) {
  setCurrentDarkMode = darkModeStateListener;
}

export async function getAPIGatewayDataFromParent(args) {
    return await postMessagePromised(window.parent, {
        method: 'getAPIGatewayDataFromParent',
        args: args
    }, '*');
}

export async function getCoralServiceDataFromParent(args) {
    return await postMessagePromised(window.parent, {
        method: 'getCoralServiceDataFromParent',
        args: args
    }, '*');
}

export async function getUserName() {
    return await postMessagePromised(window.parent, {
        method: 'getEmployeeName',
        args: {}
    }, '*');
}

export async function getLocaleFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getLocale',
        args: {}
    }, '*', 200);
}

export async function getDarkModeStatus() {
    return await postMessagePromised(
      window.parent,
      {
        method: "getDarkModeStatus",
        args: {},
      },
      "*",
    );
  }

export async function isGcaWebFeatureEnabledFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'isGcaWebFeatureEnabled',
        args: {}
    }, '*');
}

export async function getDocumentURL() {
    return await postMessagePromised(window.parent, {
        method: 'getDocumentURL',
        args: {}
    }, '*');
}

export function publishClientSideMetrics(args) {
    window.parent.postMessage({
        method: 'publishClientSideMetrics',
        args: args
    }, "*");
}

window.addEventListener("message", onNewPostMessageFromParent, false);

function onNewPostMessageFromParent(event) {
    if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
        subscribeAbleEvents[event.data.method](event.data);
    }
}

const subscribeAbleEvents = {
    sendApiGatewayResponse,
    sendEmployeeNameResponse,
    sendCoralServiceData,
    sendLocaleResponse,
    sendGcaWebEnabled,
    sendDarkModeStatus,
    sendDocumentURL,
}

function sendDarkModeStatus(data) {
    if (data.childData.capability === "dark") {
      setCurrentDarkMode("dark");
    } else {
      setCurrentDarkMode("light");
    }
}

function sendApiGatewayResponse(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendCoralServiceData(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendEmployeeNameResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendLocaleResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendGcaWebEnabled(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendDocumentURL(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}



// WEBPACK FOOTER //
// ./src/handlers/ParentDataHandler.js